import { OrchidDriveUploadTask } from "../types";

type OrchidDriveUploadTasksReducerResetAction = {
  type: "reset";
};

type OrchidDriveUploadTasksReducerUpdateAction = {
  type: "update";
  uploadTasks: OrchidDriveUploadTask[];
  oldTimeStampThreshold: number;
};

function anyUpdated(
  uploadTasks: Map<string, OrchidDriveUploadTask>,
  uploadTasksUpdate: OrchidDriveUploadTask[],
): boolean {
  return uploadTasksUpdate.some((e) => {
    const uploadTask = uploadTasks.get(e.uploadTaskId);
    if (!uploadTask) return true;
    return e.modifyDatetime.getTime() > uploadTask.modifyDatetime.getTime();
  });
}

function filterOutOldCompletedUploadTasks(
  state: Map<string, OrchidDriveUploadTask>,
  oldTimeStampThreshold: number,
): Map<string, OrchidDriveUploadTask> {
  const oldTasks: Set<OrchidDriveUploadTask> = new Set();
  for (const uploadTask of state.values()) {
    if (
      uploadTask.modifyDatetime.getTime() < oldTimeStampThreshold &&
      uploadTask.uploadFinalizedDatetime
    ) {
      oldTasks.add(uploadTask);
    }
  }
  if (oldTasks.size === 0) return state;

  const newState = new Map();
  for (const uploadTask of state.values()) {
    if (!oldTasks.has(uploadTask)) {
      newState.set(uploadTask.uploadTaskId, uploadTask);
    }
  }
  return newState;
}

export default function OrchidDriveUploadTasksReducer(
  state: Map<string, OrchidDriveUploadTask>,
  action:
    | OrchidDriveUploadTasksReducerResetAction
    | OrchidDriveUploadTasksReducerUpdateAction,
) {
  switch (action.type) {
    case "reset": {
      if (state.size === 0) return state;
      return new Map();
    }
    case "update": {
      if (!anyUpdated(state, action.uploadTasks)) {
        return state;
      }

      const newState: Map<string, OrchidDriveUploadTask> = new Map(state);

      for (const update of action.uploadTasks) {
        const uploadTask = newState.get(update.uploadTaskId);
        if (
          !uploadTask ||
          update.modifyDatetime.getTime() > uploadTask.modifyDatetime.getTime()
        ) {
          newState.set(update.uploadTaskId, update);
        }
      }

      return filterOutOldCompletedUploadTasks(
        newState,
        action.oldTimeStampThreshold,
      );
    }
  }
  throw new Error(`unexpected action type: ${action}`);
}
